import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import IncomerLog from './IncomerLog/IncomerLog';
import IncomerChart from './IncomerChart/IncomerChart';
import IncomerChart2 from './IncomerChart2/IncomerChart2';
import IncomerHourlyLog from './IncomerHourlyLog/IncomerHourlyLog';


export default function IncomerTabs({ TabTitle, ID }) {
    console.log("incomer_ID", ID)
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));


    const [key, setKey] = useState('Chart1');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }




    return (
        <Box>

            <Box mt={spacing(1)}>
                <Tabs
                    style={{ justifyContent: "flex-start" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >

                    <Tab eventKey="Chart1" title="Chart1">
                        <IncomerChart TabTitle={TabTitle} ID={ID} />
                    </Tab>

                    <Tab eventKey="Chart2" title="Chart2">
                        <IncomerChart2 TabTitle={TabTitle} ID={ID} />
                    </Tab>

                    <Tab eventKey="Log" title="Log">
                        <IncomerLog TabTitle={TabTitle} ID={ID} />
                    </Tab>

                     <Tab eventKey="Hourly Log Report" title="Hourly Log Report">
                        <IncomerHourlyLog TabTitle={TabTitle} ID={ID} />
                    </Tab>



                </Tabs>
            </Box>
        </Box>

    )
}